export default __webpack_public_path__ + "static/media/Nicolas_Bejar.9b6c1985.png";